import axios from "axios";

// ISO country list with FATF risk flags.
// risk: "high" marks exactly the countries the backend CRA scores 4-5 for
// Geographic Risk — the FATF black and grey lists (backend/jurisdictions/
// _fatf_lists.json, June 2026 plenary), the sanctioned jurisdictions and the
// product's elevated tier (cra_service.SANCTIONED_JURISDICTIONS /
// ELEVATED_RISK_COUNTRIES). backend/tests/test_fatf_lists.py fails the build
// if this table and those sets disagree, so refresh them together.
export const COUNTRIES = [
  { code: "MU", name: "Mauritius", risk: "low" },
  { code: "AF", name: "Afghanistan", risk: "high" },
  { code: "AL", name: "Albania", risk: "low" },
  { code: "DZ", name: "Algeria", risk: "low" },
  { code: "AD", name: "Andorra", risk: "low" },
  { code: "AO", name: "Angola", risk: "high" },
  { code: "AG", name: "Antigua and Barbuda", risk: "low" },
  { code: "AR", name: "Argentina", risk: "low" },
  { code: "AM", name: "Armenia", risk: "low" },
  { code: "AU", name: "Australia", risk: "low" },
  { code: "AT", name: "Austria", risk: "low" },
  { code: "AZ", name: "Azerbaijan", risk: "low" },
  { code: "BS", name: "Bahamas", risk: "low" },
  { code: "BH", name: "Bahrain", risk: "low" },
  { code: "BD", name: "Bangladesh", risk: "low" },
  { code: "BB", name: "Barbados", risk: "low" },
  { code: "BY", name: "Belarus", risk: "medium" },
  { code: "BE", name: "Belgium", risk: "low" },
  { code: "BZ", name: "Belize", risk: "low" },
  { code: "BJ", name: "Benin", risk: "low" },
  { code: "BT", name: "Bhutan", risk: "low" },
  { code: "BO", name: "Bolivia", risk: "high" },
  { code: "BA", name: "Bosnia and Herzegovina", risk: "high" },
  { code: "BW", name: "Botswana", risk: "low" },
  { code: "BR", name: "Brazil", risk: "low" },
  { code: "BN", name: "Brunei", risk: "low" },
  { code: "BG", name: "Bulgaria", risk: "high" },
  { code: "BF", name: "Burkina Faso", risk: "medium" },
  { code: "BI", name: "Burundi", risk: "medium" },
  { code: "CV", name: "Cabo Verde", risk: "low" },
  { code: "KH", name: "Cambodia", risk: "medium" },
  { code: "CM", name: "Cameroon", risk: "high" },
  { code: "CA", name: "Canada", risk: "low" },
  { code: "CF", name: "Central African Republic", risk: "high" },
  { code: "TD", name: "Chad", risk: "medium" },
  { code: "CL", name: "Chile", risk: "low" },
  { code: "CN", name: "China", risk: "low" },
  { code: "CO", name: "Colombia", risk: "medium" },
  { code: "KM", name: "Comoros", risk: "low" },
  { code: "CD", name: "Congo, DRC", risk: "high" },
  { code: "CG", name: "Congo, Republic", risk: "medium" },
  { code: "CR", name: "Costa Rica", risk: "low" },
  { code: "CI", name: "Côte d'Ivoire", risk: "high" },
  { code: "HR", name: "Croatia", risk: "medium" },
  { code: "CU", name: "Cuba", risk: "high" },
  { code: "CY", name: "Cyprus", risk: "medium" },
  { code: "CZ", name: "Czech Republic", risk: "low" },
  { code: "DK", name: "Denmark", risk: "low" },
  { code: "DJ", name: "Djibouti", risk: "medium" },
  { code: "DO", name: "Dominican Republic", risk: "medium" },
  { code: "EC", name: "Ecuador", risk: "low" },
  { code: "EG", name: "Egypt", risk: "medium" },
  { code: "SV", name: "El Salvador", risk: "medium" },
  { code: "GQ", name: "Equatorial Guinea", risk: "medium" },
  { code: "ER", name: "Eritrea", risk: "high" },
  { code: "EE", name: "Estonia", risk: "low" },
  { code: "SZ", name: "Eswatini", risk: "low" },
  { code: "ET", name: "Ethiopia", risk: "medium" },
  { code: "FJ", name: "Fiji", risk: "low" },
  { code: "FI", name: "Finland", risk: "low" },
  { code: "FR", name: "France", risk: "low" },
  { code: "GA", name: "Gabon", risk: "low" },
  { code: "GM", name: "Gambia", risk: "medium" },
  { code: "GE", name: "Georgia", risk: "low" },
  { code: "DE", name: "Germany", risk: "low" },
  { code: "GH", name: "Ghana", risk: "low" },
  { code: "GR", name: "Greece", risk: "low" },
  { code: "GT", name: "Guatemala", risk: "medium" },
  { code: "GN", name: "Guinea", risk: "medium" },
  { code: "GW", name: "Guinea-Bissau", risk: "high" },
  { code: "GY", name: "Guyana", risk: "low" },
  { code: "HT", name: "Haiti", risk: "high" },
  { code: "HN", name: "Honduras", risk: "medium" },
  { code: "HU", name: "Hungary", risk: "low" },
  { code: "IS", name: "Iceland", risk: "low" },
  { code: "IN", name: "India", risk: "low" },
  { code: "ID", name: "Indonesia", risk: "low" },
  { code: "IR", name: "Iran", risk: "high" },
  { code: "IQ", name: "Iraq", risk: "high" },
  { code: "IE", name: "Ireland", risk: "low" },
  { code: "IL", name: "Israel", risk: "low" },
  { code: "IT", name: "Italy", risk: "low" },
  { code: "JM", name: "Jamaica", risk: "medium" },
  { code: "JP", name: "Japan", risk: "low" },
  { code: "JO", name: "Jordan", risk: "low" },
  { code: "KZ", name: "Kazakhstan", risk: "medium" },
  { code: "KE", name: "Kenya", risk: "high" },
  { code: "KI", name: "Kiribati", risk: "low" },
  { code: "KW", name: "Kuwait", risk: "high" },
  { code: "KG", name: "Kyrgyzstan", risk: "medium" },
  { code: "LA", name: "Laos", risk: "high" },
  { code: "LV", name: "Latvia", risk: "low" },
  { code: "LB", name: "Lebanon", risk: "high" },
  { code: "LS", name: "Lesotho", risk: "low" },
  { code: "LR", name: "Liberia", risk: "medium" },
  { code: "LY", name: "Libya", risk: "high" },
  { code: "LI", name: "Liechtenstein", risk: "low" },
  { code: "LT", name: "Lithuania", risk: "low" },
  { code: "LU", name: "Luxembourg", risk: "low" },
  { code: "MG", name: "Madagascar", risk: "low" },
  { code: "MW", name: "Malawi", risk: "medium" },
  { code: "MY", name: "Malaysia", risk: "low" },
  { code: "MV", name: "Maldives", risk: "low" },
  { code: "ML", name: "Mali", risk: "medium" },
  { code: "MT", name: "Malta", risk: "low" },
  { code: "MH", name: "Marshall Islands", risk: "low" },
  { code: "MR", name: "Mauritania", risk: "medium" },
  { code: "MX", name: "Mexico", risk: "medium" },
  { code: "FM", name: "Micronesia", risk: "low" },
  { code: "MD", name: "Moldova", risk: "medium" },
  { code: "MC", name: "Monaco", risk: "high" },
  { code: "MN", name: "Mongolia", risk: "low" },
  { code: "ME", name: "Montenegro", risk: "medium" },
  { code: "MA", name: "Morocco", risk: "low" },
  { code: "MZ", name: "Mozambique", risk: "medium" },
  { code: "MM", name: "Myanmar", risk: "high" },
  { code: "NA", name: "Namibia", risk: "medium" },
  { code: "NP", name: "Nepal", risk: "high" },
  { code: "NL", name: "Netherlands", risk: "low" },
  { code: "NZ", name: "New Zealand", risk: "low" },
  { code: "NI", name: "Nicaragua", risk: "medium" },
  { code: "NE", name: "Niger", risk: "medium" },
  { code: "NG", name: "Nigeria", risk: "medium" },
  { code: "KP", name: "North Korea", risk: "high" },
  { code: "MK", name: "North Macedonia", risk: "low" },
  { code: "NO", name: "Norway", risk: "low" },
  { code: "OM", name: "Oman", risk: "low" },
  { code: "PK", name: "Pakistan", risk: "high" },
  { code: "PW", name: "Palau", risk: "low" },
  { code: "PA", name: "Panama", risk: "medium" },
  { code: "PG", name: "Papua New Guinea", risk: "high" },
  { code: "PY", name: "Paraguay", risk: "medium" },
  { code: "PE", name: "Peru", risk: "medium" },
  { code: "PH", name: "Philippines", risk: "medium" },
  { code: "PL", name: "Poland", risk: "low" },
  { code: "PT", name: "Portugal", risk: "low" },
  { code: "QA", name: "Qatar", risk: "low" },
  { code: "RE", name: "Reunion", risk: "low" },
  { code: "RO", name: "Romania", risk: "low" },
  { code: "RU", name: "Russia", risk: "high" },
  { code: "RW", name: "Rwanda", risk: "low" },
  { code: "KN", name: "Saint Kitts and Nevis", risk: "low" },
  { code: "LC", name: "Saint Lucia", risk: "low" },
  { code: "VC", name: "Saint Vincent and Grenadines", risk: "low" },
  { code: "WS", name: "Samoa", risk: "low" },
  { code: "SM", name: "San Marino", risk: "low" },
  { code: "ST", name: "Sao Tome and Principe", risk: "low" },
  { code: "SA", name: "Saudi Arabia", risk: "low" },
  { code: "SN", name: "Senegal", risk: "medium" },
  { code: "RS", name: "Serbia", risk: "medium" },
  { code: "SC", name: "Seychelles", risk: "low" },
  { code: "SL", name: "Sierra Leone", risk: "medium" },
  { code: "SG", name: "Singapore", risk: "low" },
  { code: "SK", name: "Slovakia", risk: "low" },
  { code: "SI", name: "Slovenia", risk: "low" },
  { code: "SB", name: "Solomon Islands", risk: "low" },
  { code: "SO", name: "Somalia", risk: "high" },
  { code: "ZA", name: "South Africa", risk: "low" },
  { code: "SS", name: "South Sudan", risk: "high" },
  { code: "ES", name: "Spain", risk: "low" },
  { code: "LK", name: "Sri Lanka", risk: "medium" },
  { code: "SD", name: "Sudan", risk: "high" },
  { code: "SR", name: "Suriname", risk: "medium" },
  { code: "SE", name: "Sweden", risk: "low" },
  { code: "CH", name: "Switzerland", risk: "low" },
  { code: "SY", name: "Syria", risk: "high" },
  { code: "TW", name: "Taiwan", risk: "low" },
  { code: "TJ", name: "Tajikistan", risk: "medium" },
  { code: "TZ", name: "Tanzania", risk: "medium" },
  { code: "TH", name: "Thailand", risk: "low" },
  { code: "TL", name: "Timor-Leste", risk: "medium" },
  { code: "TG", name: "Togo", risk: "medium" },
  { code: "TO", name: "Tonga", risk: "low" },
  { code: "TT", name: "Trinidad and Tobago", risk: "medium" },
  { code: "TN", name: "Tunisia", risk: "medium" },
  { code: "TR", name: "Turkey", risk: "medium" },
  { code: "TM", name: "Turkmenistan", risk: "high" },
  { code: "UG", name: "Uganda", risk: "medium" },
  { code: "UA", name: "Ukraine", risk: "medium" },
  { code: "AE", name: "United Arab Emirates", risk: "medium" },
  { code: "GB", name: "United Kingdom", risk: "low" },
  { code: "US", name: "United States", risk: "low" },
  { code: "UY", name: "Uruguay", risk: "low" },
  { code: "UZ", name: "Uzbekistan", risk: "medium" },
  { code: "VU", name: "Vanuatu", risk: "medium" },
  { code: "VE", name: "Venezuela", risk: "high" },
  { code: "VN", name: "Vietnam", risk: "high" },
  { code: "VG", name: "Virgin Islands (British)", risk: "high" },
  { code: "YE", name: "Yemen", risk: "high" },
  { code: "ZM", name: "Zambia", risk: "medium" },
  { code: "ZW", name: "Zimbabwe", risk: "high" },
];

export const SOURCE_OF_FUNDS = [
  { value: "Salary/Employment Income", label: "Salary / Employment Income" },
  { value: "Savings/Investments", label: "Savings / Investments" },
  { value: "Business Profits", label: "Business Profits" },
  { value: "Inheritance", label: "Inheritance" },
  { value: "Gift", label: "Gift" },
  { value: "Loan", label: "Loan" },
  { value: "Pension/Retirement Fund", label: "Pension / Retirement Fund" },
  { value: "Sale of Assets", label: "Sale of Assets" },
  { value: "Rental Income", label: "Rental Income" },
  { value: "Dividends/Interest", label: "Dividends / Interest from Investments" },
  { value: "Insurance Payout", label: "Insurance Payout" },
  { value: "Legal Settlement/Compensation", label: "Legal Settlement / Compensation" },
  { value: "Government Benefits", label: "Government Benefits / Social Assistance" },
  { value: "Freelance/Consulting Fees", label: "Freelance / Consulting Fees" },
  { value: "Self-Employment Income", label: "Self-Employment Income (sole trader / independent)" },
  { value: "Royalties", label: "Royalties" },
  { value: "Gambling/Lottery Winnings", label: "Gambling / Lottery Winnings" },
  { value: "Other", label: "Other (please specify)" },
];

// Per-source funding stage for staged property transactions (e.g. CRP +
// loan drawn at milestone payments). See SourcesStep.jsx for the UI and
// screening_service.py / cra_service.py for the back-end semantics.
export const FUNDING_STAGES = [
  { value: "paid_at_signing", label: "Funds paid at signing", help: "Default — funds already paid, supporting documents required." },
  { value: "future_drawdown", label: "Funds not yet drawn (deferred)", help: "Use for a loan that will cover later milestone payments. A Preliminary Contract (CRP) must be uploaded; draft is accepted now, signed required when funds are drawn." },
  { value: "completed", label: "Drawn and verified", help: "Funds drawn and supporting documents uploaded. Treated like paid-at-signing for the screening." },
];

export const TRANSACTION_TYPES = [
  "Acquisition / Purchase / Sale",
  "VEFA (Vente en Etat Futur d'Achevement)",
  "SCIA (Societe Civile Immobiliere d'Attribution)",
  "Rental / Lease",
  "Part-payment / Instalment Sale",
];

export const PROPERTY_TYPES = [
  "Immovable Property",
  "Motor Vehicle",
  "Jewellery / Precious Metal",
  "Marine / Watercraft Asset",
  "Aircraft / Helicopter",
  "Artwork",
  "Other",
];

export const PROPERTY_SUBCATEGORIES = {
  "Immovable Property": [
    "Residential Land / Plot",
    "Agricultural Land",
    "Villa / House",
    "Apartment / Flat",
    "Commercial Building / Office",
    "Industrial Land / Factory",
    "Other Immovable (e.g., leasehold rights, servitude)",
  ],
  "Motor Vehicle": [
    "Motor Vehicle (car, van, etc.)",
    "Utility Truck / Pickup",
    "Motorcycle",
    "Bus / Minibus",
    "Heavy Machinery / Construction Vehicle",
  ],
  "Jewellery / Precious Metal": [
    "Luxury Watch",
    "Finished Jewellery (Gold-Based)",
    "Finished Jewellery (with Precious Stones/Gems)",
    "Loose / Cut Precious Stones (Gems)",
    "Pearls (Natural or Cultured)",
  ],
  "Marine / Watercraft Asset": [
    "Boat / Yacht",
    "Fishing Vessel",
    "Other Watercraft (e.g., jet ski)",
  ],
  "Aircraft / Helicopter": [
    "Aircraft / Plane",
    "Helicopter",
    "Drone (commercial/high-value only)",
  ],
  "Artwork": [
    "Painting",
    "Sculpture",
    "Drawing",
    "Photograph",
    "Engraving",
    "Woodwork",
  ],
};

export const ENTITY_TYPES = [
  { value: "individual", label: "Individual" },
  { value: "domestic_company", label: "Domestic Company" },
  { value: "civil_partnership", label: "Civil Partnership" },
  { value: "trust", label: "Trust" },
  { value: "gbc", label: "Global Business Company" },
  { value: "authorised_company", label: "Authorised Company" },
  { value: "association", label: "Association" },
  { value: "undetermined", label: "Undetermined" },
];

// How the firm met a party. The values are backend
// cra_service.DELIVERY_CHANNELS, the labels deliveryChannel.<value> in the
// locale files. The CRA's Delivery Channel Risk scores them 1 (face to face)
// to 4 (third-party introducer); unrecorded, a party scores 3.
export const DELIVERY_CHANNELS = [
  "face_to_face", "intermediary", "remote", "third_party_introducer",
];

export const PAYMENT_TERMS = [
  "One-time payment",
  "Part-payment / Instalment",
  "Payment Schedule (multiple milestones)",
  "Monthly Payment",
  "Loan / Lease - Financed",
  "Other",
];

export const MODES_OF_PAYMENT = [
  "Cash",
  "Cheque",
  "Bank Transfer",
  "Debit/Credit Card",
  "Mixed (Cash + Bank Transfer)",
  "Mixed (Cash + Cheque)",
  "Escrow",
  "Other",
];

export const SOURCE_DOCUMENT_SUGGESTIONS = {
  "Salary/Employment Income": {
    documents: [
      "Recent pay slips (3-6 months)",
      "Income tax return (MRA IT1) - latest or multiple years",
      "Bank statements showing salary credits",
      "PAYE summary / tax deduction certificate",
    ],
    purpose: "Confirm regular, legitimate income matching occupation",
    risk: "Low risk if consistent; EDD if unusually high for occupation",
  },
  "Savings/Investments": {
    documents: [
      "Bank / savings account statements (6-12 months)",
      "Fixed deposit / investment certificates",
      "Interest income statements",
    ],
    purpose: "Show accumulation over time, no sudden large deposits",
    risk: "Medium risk if large unexplained lump sums appear",
  },
  "Business Profits": {
    documents: [
      "Financial statements or management accounts",
      "VAT returns (quarterly - upload successive quarters for best coverage)",
      "Business tax returns (MRA)",
      "Company registration / BRN extract",
      "Bank statements of business account",
    ],
    purpose: "Link profits to declared business activity",
    risk: "High risk if new business or inconsistent with occupation",
  },
  "Inheritance": {
    documents: [
      "Probate / letters of administration",
      "Death certificate",
      "Will (certified copy)",
      "Notary deed of partition / transfer",
      "Bank transfer proof",
    ],
    purpose: "Confirm legitimate estate distribution",
    risk: "High risk if large amount + young buyer or complex family",
  },
  "Gift": {
    documents: [
      "Notarized gift deed / affidavit from donor",
      "Donor's proof of source of funds",
      "Bank transfer / cheque copy",
      "Relationship proof (birth cert, marriage cert if family)",
    ],
    purpose: "Verify donor can afford gift and funds are clean",
    risk: "Very high risk if large gift from unrelated party",
  },
  "Loan": {
    documents: [
      "Loan / mortgage approval letter",
      "Loan agreement",
      "Repayment schedule",
      "Bank statement showing disbursement",
    ],
    purpose: "Confirm legitimate borrowing and ability to repay",
    risk: "Medium-high risk if private loan or from high-risk jurisdiction",
  },
  "Pension/Retirement Fund": {
    documents: [
      "Pension fund statement / withdrawal letter",
      "Retirement benefit approval",
      "Tax certificate on pension income",
      "Bank credit proof",
    ],
    purpose: "Verify official retirement source",
    risk: "Low risk unless unusually large early withdrawal",
  },
  "Sale of Assets": {
    documents: [
      "Sale agreement / deed (previous property, vehicle, etc.)",
      "Title transfer / registration docs",
      "Capital gains tax receipt (if applicable)",
      "Bank statement showing proceeds",
    ],
    purpose: "Trace chain of funds from legitimate sale",
    risk: "Medium risk if chain is incomplete or recent",
  },
  "Rental Income": {
    documents: [
      "Lease agreements",
      "Tenant payment receipts / bank credits",
      "Rental income tax declaration",
      "Property title extract",
    ],
    purpose: "Confirm ongoing legitimate income stream",
    risk: "Low-medium risk; check if property ownership matches",
  },
  "Dividends/Interest": {
    documents: [
      "Dividend statements / warrants",
      "Investment portfolio summary",
      "Brokerage / bank statements",
      "Tax certificate (withholding tax)",
    ],
    purpose: "Link to declared investment holdings",
    risk: "Medium risk if large and no prior investment history",
  },
  "Insurance Payout": {
    documents: [
      "Insurance policy document",
      "Claim settlement letter",
      "Payout confirmation / bank transfer",
    ],
    purpose: "Verify legitimate claim event",
    risk: "Medium risk if recent large payout",
  },
  "Legal Settlement/Compensation": {
    documents: [
      "Court order / settlement agreement",
      "Lawyer's confirmation letter",
      "Bank receipt of funds",
    ],
    purpose: "Confirm court-approved or regulated source",
    risk: "High risk if recent or large amount",
  },
  "Government Benefits": {
    documents: [
      "Official award letter (Ministry / NGO)",
      "Payment vouchers / bank credits",
      "Eligibility proof",
    ],
    purpose: "Verify state or recognized program",
    risk: "Low risk unless unusually large",
  },
  "Freelance/Consulting Fees": {
    documents: [
      "Invoices issued",
      "Service contracts",
      "Self-employed tax return",
      "Bank statements with deposits",
    ],
    purpose: "Match to declared occupation",
    risk: "Medium-high risk if large and no track record",
  },
  "Self-Employment Income": {
    documents: [
      "Income tax returns (self-assessment / MRA) - latest or multiple years",
      "VAT returns (quarterly - if VAT registered)",
      "Business bank statements (6-12 months)",
      "BRN registration / sole trader certificate",
      "Invoices and receipts from clients",
      "Financial statements or profit & loss account",
    ],
    purpose: "Verify legitimate self-employment income and its consistency over time",
    risk: "Medium risk; higher if income is volatile, undocumented, or new activity",
  },
  "Royalties": {
    documents: [
      "Royalty statements",
      "Licensing / publishing agreement",
      "Tax return on royalties",
    ],
    purpose: "Confirm legitimate IP ownership",
    risk: "Medium risk unless buyer has known creative/professional history",
  },
  "Gambling/Lottery Winnings": {
    documents: [
      "Official win certificate / letter from organizer",
      "Tax payment receipt (if applicable)",
      "Bank deposit proof",
    ],
    purpose: "Verify regulated, legal win",
    risk: "Very high risk - strong suspicion indicator",
  },
  "Other": {
    documents: [
      "Documents that best prove legitimacy and origin of funds",
    ],
    purpose: "Full traceability required",
    risk: "Almost always triggers EDD + possible STR consideration",
  },
};

export const DONOR_DOCUMENT_SUGGESTIONS = {
  "Donor ID Document": {
    documents: [
      "National Identity Card (NIC) - certified true copy",
      "Valid Passport - certified true copy",
    ],
    purpose: "Verify the identity of the gift donor",
  },
  "Donor Proof of Address": {
    documents: [
      "Utility bill (electricity, water, gas, internet) - less than 3 months old",
      "Bank statement or bank-issued letter - less than 3 months old",
      "Lease agreement or tenancy contract (signed and dated) - less than 3 months old",
      "Insurance policy schedule showing residential address - less than 3 months old",
    ],
    purpose: "Verify the residential address of the gift donor",
  },
  "Donor Source of Funds": {
    documents: [
      "Recent pay slips or income tax return",
      "Bank statements showing sufficient funds",
      "Financial statements (if business owner)",
      "Investment portfolio or savings account statements",
    ],
    purpose: "Verify the donor can afford the gift and funds are legitimate",
  },
  "Gift Deed / Affidavit": {
    documents: [
      "Notarized gift deed or affidavit from donor",
      "Signed declaration of gift with amounts and purpose",
      "Bank transfer / cheque copy showing gift payment",
      "Relationship proof (birth certificate, marriage certificate if family)",
    ],
    purpose: "Formal declaration of gift and proof of transfer",
  },
};

// Every kind a proof of address is accepted as, each held to the same date
// rule: less than three months old (backend screening_service.py, the proof
// of address rule; doc_currency.evaluate_poa_currency). Government
// correspondence and tax notices are not accepted.
export const PROOF_OF_ADDRESS_DOCS = [
  "Utility bill (electricity, water, gas, internet) - less than 3 months old, certified true copy",
  "Bank statement or bank-issued letter - less than 3 months old, certified true copy",
  "Lease agreement or tenancy contract (signed and dated) - less than 3 months old, certified true copy",
  "Insurance policy schedule showing residential address - less than 3 months old, certified true copy",
];

export const ID_DOCUMENTS = [
  "National Identity Card (NIC) - certified true copy",
  "Valid Passport - certified true copy",
  "Birth Certificate (for minors) - certified true copy",
];

// Financial Crimes Commission Act — cash transaction limit.
//
// The threshold and the exchange rates used to be literals right here, a
// second copy of backend/transaction_routes.py's table in a second language.
// They agreed on the day they were written and nothing kept them in step;
// both were nine months stale and understating EUR by 9.5%. They now come
// from the backend, which reads them from transactions_fx_rates.
//
// This is the ADVISORY copy — it turns the warning banner on before the user
// submits. The enforcement is the backend's (fcc_cash_limit.py), and stays
// correct whatever this does, which is why failing to load is allowed to
// mean "show no warning" rather than "block the form".
let _fcc = null;
let _fccInFlight = null;

export const loadFccCashLimit = () => {
  if (_fcc) return Promise.resolve(_fcc);
  if (!_fccInFlight) {
    _fccInFlight = axios
      .get("/api/transactions/fcc-cash-limit")
      .then(({ data }) => { _fcc = data; return _fcc; })
      .catch(() => { _fccInFlight = null; return null; });
  }
  return _fccInFlight;
};

export const getFccCashLimit = () => _fcc;

/** MUR 500,000, as the backend renders it — never assembled here. */
export const fccThresholdDisplay = () => _fcc?.threshold_display || "";

/** The currencies we hold a rate for, so the picker cannot offer one the
 *  backend will refuse. MUR first: it converts at 1 by definition and is
 *  never an FX row. */
export const fccCurrencies = () => {
  const domestic = _fcc?.domestic_currency || "MUR";
  const rated = Object.keys(_fcc?.rates || {}).sort();
  return [domestic, ...rated.filter((c) => c !== domestic)];
};

/** Advisory only. Returns false while the config is still loading, and for a
 *  currency we hold no rate for — the backend refuses that case outright, and
 *  a banner cannot say anything useful about a conversion it cannot do. */
export const exceedsFccCashLimit = (price, currency) => {
  if (!price) return false;
  if (!_fcc) { loadFccCashLimit(); return false; }
  const code = String(currency || _fcc.domestic_currency || "MUR").toUpperCase();
  const threshold = Number(_fcc.threshold_mur);
  if (!Number.isFinite(threshold)) return false;
  if (code === (_fcc.domestic_currency || "MUR")) return price >= threshold;
  const rate = Number(_fcc.rates?.[code]);
  if (!Number.isFinite(rate)) return false;
  return Math.ceil(price * rate) >= threshold;
};

export const OWNERSHIP_DOCUMENTS = {
  "Residential Property": [
    "Title deed / Certificate of ownership",
    "Land registry extract (Registrar General)",
    "Survey plan (cadastral map)",
  ],
  "Commercial Property": [
    "Title deed / Certificate of ownership",
    "Land registry extract",
    "Business premises lease (if leasehold)",
    "Commercial property valuation report",
  ],
  "Land / Plot": [
    "Title deed",
    "Land registry extract",
    "Survey plan / cadastral plan",
    "Morcellement permit (if subdivided)",
  ],
  "Vehicle": [
    "Vehicle registration card (carte grise)",
    "Sale agreement / logbook",
    "Insurance certificate",
  ],
  "Jewellery": [
    "Certificate of authenticity / gemological certificate",
    "Original purchase receipt or invoice",
    "Independent valuation report",
  ],
  "Shares/Securities": [
    "Share certificate",
    "Broker / depository statement",
    "Company registry extract (if private shares)",
  ],
  "Artwork": [
    "Certificate of authenticity",
    "Provenance documentation",
    "Independent valuation or appraisal report",
    "Purchase receipt / auction record",
  ],
  "Vessel / Boat": [
    "Vessel registration certificate",
    "Maritime authority extract",
    "Sale agreement",
  ],
  "Aircraft": [
    "Aircraft registration certificate",
    "Civil aviation authority record",
    "Bill of sale",
  ],
  "default": [
    "Proof of ownership (title deed, certificate, registration, or receipt)",
    "Valuation report (if applicable)",
  ],
};

export const RISK_COLORS = {
  low: { bg: "#ecfdf5", text: "#047857", border: "#a7f3d0", label: "Low Risk" },
  // A CRA rating that is not folded into the badge scale, so a UBO or party
  // carrying it fell through to the grey "Pending" style.
  medium_low: { bg: "#fefce8", text: "#a16207", border: "#fef08a", label: "Medium-Low Risk" },
  medium: { bg: "#fffbeb", text: "#b45309", border: "#fde68a", label: "Medium Risk" },
  high: { bg: "#fef2f2", text: "#b91c1c", border: "#fecaca", label: "High Risk" },
  very_high: { bg: "#450a0a", text: "#fef2f2", border: "#991b1b", label: "Very High Risk" },
  pending: { bg: "#f1f5f9", text: "#64748b", border: "#e2e8f0", label: "Pending" },
};

